import { render, staticRenderFns } from "./WorkDescription.vue?vue&type=template&id=12b6f0fe&scoped=true&"
import script from "./WorkDescription.vue?vue&type=script&lang=js&"
export * from "./WorkDescription.vue?vue&type=script&lang=js&"
import style0 from "./WorkDescription.vue?vue&type=style&index=0&id=12b6f0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6f0fe",
  null
  
)

export default component.exports